export default __webpack_public_path__ + "images/9c1aeece55633199ea1a82f51c877865-thrive-congrats-en.svg";